import React, { Component, Fragment } from "react";
import { shopContext } from "../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";
import queryString from "query-string";

//import ViewContent from '../containers/main/ViewContent';
import $ from "jquery";
class AttackOnTitan extends Component {
  componentDidMount = () => {
    //window.addEventListener('resize', this._getWindowSize)
    //this._getWindowSize()
    //this._getWindowSize()
  };
  _getWindowSize = () => {
    $("img[usemap]").rwdImageMaps();
  };
  componentWillUnmount = () => {
    this._isMounted = false;
    //window.removeEventListener('resize', this._getWindowSize)
  };

  render() {
    const { location } = this.props.childProps;
    const query = queryString.parse(location.search);
    ////console.log(query)
    const code = query.code;
    ////console.log(searchList)
    return (
      <Fragment>
        <div
          style={{
            width: "100%",
            textAlign: "center",
            height: 700,
            paddingTop: 300,
          }}
        >
          <div>
            <span style={{ color: "#fff" }}>추천코드</span>
          </div>
          <div style={{ paddingTop: 20 }}>
            <span style={{ color: "#fff", fontWeight: "800", fontSize: 16 }}>
              {code}
            </span>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(AttackOnTitan));
